import { useRef, useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import styles from './HomeOffer.module.css'
import AnimatedTitle from '../../AnimatedTitle/AnimatedTitle'
import FadeInWhenVisible from '../FadeInWhenVisible/FadeInWhenVisible'
import { motion, useInView } from 'framer-motion'
import { useImagePreload } from '../../../hooks/useImagePreload'
import { ApiService } from '../../../services/api'
import Image from '../../ui/Image/Image'

const HomeOffer = () => {
  const [swiperReady, setSwiperReady] = useState(false)
  const [bannerUrls, setBannerUrls] = useState<string[]>([])
  useImagePreload(bannerUrls[0])

  useEffect(() => {
    ApiService.getConfig()
      .then(config => {
        setBannerUrls(config.bannerUrls ?? [])
      })
      .catch(() => {})
  }, [])

  const prevRef = useRef<HTMLButtonElement | null>(null)
  const nextRef = useRef<HTMLButtonElement | null>(null)
  const paginationRef = useRef<HTMLDivElement | null>(null)

  // Чекаємо, поки refs стануть доступними
  useEffect(() => {
    if (prevRef.current && nextRef.current && paginationRef.current) {
      setSwiperReady(true)
    }
  }, [])

  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, amount: 0.3 })

  return (
    <section className={styles.homeOffer}>
      <div className={styles.left}>
        {/* Brand poetic headline. Intentionally an h2 so it does not compete
            with the page-level SEO h1 rendered in HomePage.tsx (sr-only).
            Visual styling is unchanged. */}
        <AnimatedTitle
          as="h2"
          text={['seaters ', '— зустріч на', ' каву з собою']}
          className={styles.title}
        />

        <FadeInWhenVisible delay={0.2} y={20}>
          <p className={styles.desc}>
            Тільки ти, твоя кава і твій простір. Наздоганяти дедлайни, тонути в рядках захопливої
            книжки, заворожено спостерігати за перехожими
            <span> — свій seaters-moment обираєш тільки ти.</span>
          </p>
        </FadeInWhenVisible>

        <FadeInWhenVisible delay={0.3} y={30}>
          <a href="/shop" className={styles.button}>
            <svg
              className={styles.buttonIcon}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M10.9727 17.2222V17.2222C10.9727 13.2335 14.2062 10 18.1949 10L20.0004 10"
                stroke="white"
                strokeWidth="2"
                strokeLinejoin="bevel"
              />
              <path
                d="M10.9727 2.77777V2.77777C10.9727 6.7665 14.2062 9.99999 18.1949 9.99999L20.0004 9.99999"
                stroke="white"
                strokeWidth="2"
                strokeLinejoin="bevel"
              />
              <path d="M20 10L0 10" stroke="white" strokeWidth="2" />
            </svg>
            В каталог
          </a>
        </FadeInWhenVisible>
        <img
          className={styles.chairBg}
          src="/images/seatElement.svg"
          alt=""
          width={425}
          height={355}
          loading="lazy"
        />
      </div>
      <div className={styles.right}>
        <div className={styles.coffeeCard}>
          {swiperReady && bannerUrls.length > 0 && (
            <Swiper
              spaceBetween={0}
              slidesPerView={1}
              loop={true}
              modules={[Navigation, Pagination, Autoplay]}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              navigation={{
                prevEl: prevRef.current!,
                nextEl: nextRef.current!,
              }}
              pagination={{
                el: paginationRef.current!,
                clickable: true,
              }}
              className={styles.swiper}
            >
              {bannerUrls.map((url, idx) => (
                <SwiperSlide key={idx}>
                  <div className={styles.slideWrap}>
                    <Image
                      src={url}
                      alt="Seaters Coffee"
                      sizes="(min-width: 1024px) 50vw, 100vw"
                      className={styles.slideImage}
                      loading={idx === 0 ? 'eager' : 'lazy'}
                      fetchPriority={idx === 0 ? 'high' : 'auto'}
                    />
                    {/* <div className={styles.coffeeTextBlock}>
                      <h2 className={styles.coffeeTitle}>
                        {slide.title.split('\n').map((t, i) => (
                          <span key={i}>
                            {t}
                            <br />
                          </span>
                        ))}
                      </h2>
                      <p className={styles.coffeeDesc}>{slide.desc}</p>
                      <div className={styles.coffeePlace}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className={styles.placeIcon}
                          viewBox="0 0 29 30"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_1_53)">
                            <path
                              d="M14.6031 0.399963C8.85184 0.399963 4.17285 5.07895 4.17285 10.8302C4.17285 17.9676 13.5069 28.4458 13.9043 28.8884C14.2776 29.3041 14.9293 29.3034 15.3019 28.8884C15.6993 28.4458 25.0334 17.9676 25.0334 10.8302C25.0333 5.07895 20.3543 0.399963 14.6031 0.399963ZM14.6031 16.0779C11.7095 16.0779 9.35545 13.7238 9.35545 10.8302C9.35545 7.93656 11.7096 5.5825 14.6031 5.5825C17.4967 5.5825 19.8507 7.93662 19.8507 10.8302C19.8507 13.7238 17.4967 16.0779 14.6031 16.0779Z"
                              fill="#0D0D0D"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1_53">
                              <rect
                                width="28.8"
                                height="28.8"
                                fill="white"
                                transform="translate(0.200195 0.399963)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        {slide.place}
                      </div>
                    </div> */}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
          <div className={styles.navigationWrap}>
            <button
              ref={prevRef}
              className={`swiper-prev ${styles.swiperNavBtn}`}
              aria-label="Попередній банер"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                <path
                  d="M9.02734 17.2222V17.2222C9.02734 13.2335 5.79384 10 1.80512 10L-0.000433845 10"
                  stroke="#0D0D0D"
                  strokeWidth="2"
                  strokeLinejoin="bevel"
                />
                <path
                  d="M9.02734 2.77777V2.77777C9.02734 6.7665 5.79384 9.99999 1.80512 9.99999L-0.000434476 9.99999"
                  stroke="#0D0D0D"
                  strokeWidth="2"
                  strokeLinejoin="bevel"
                />
                <path d="M1.54972e-06 10L20 10" stroke="#0D0D0D" strokeWidth="2" />
              </svg>
            </button>
            <div
              ref={paginationRef}
              className={`swiper-pagination ${styles.swiperPagination}`}
            ></div>
            <button
              ref={nextRef}
              className={`swiper-next ${styles.swiperNavBtn}`}
              aria-label="Наступний банер"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                <path
                  d="M10.9727 17.2222V17.2222C10.9727 13.2335 14.2062 10 18.1949 10L20.0004 10"
                  stroke="#0D0D0D"
                  strokeWidth="2"
                  strokeLinejoin="bevel"
                />
                <path
                  d="M10.9727 2.77777V2.77777C10.9727 6.7665 14.2062 9.99999 18.1949 9.99999L20.0004 9.99999"
                  stroke="#0D0D0D"
                  strokeWidth="2"
                  strokeLinejoin="bevel"
                />
                <path d="M20 10L0 10" stroke="#0D0D0D" strokeWidth="2" />
              </svg>
            </button>
          </div>
        </div>
        <div className={styles.verticalText}>
          <svg viewBox="0 0 183 890" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M123.085 97.2823C129.753 96.6211 134.934 93.7834 138.626 88.7691C142.318 83.7548 144.164 76.9497 144.164 68.3539C144.164 62.5131 143.338 57.5814 141.685 53.559C140.086 49.5366 137.854 46.4509 134.989 44.3019C132.123 42.208 128.872 41.1611 125.235 41.1611C122.204 41.0509 119.558 41.6846 117.299 43.0621C115.039 44.4948 113.083 46.4509 111.43 48.9305C109.832 51.41 108.426 54.2753 107.214 57.5263C106.057 60.7774 105.065 64.2488 104.238 67.9406L100.601 83.1487C98.9477 90.5324 96.7434 97.3099 93.9879 103.481C91.2325 109.653 87.8433 114.998 83.8204 119.516C79.7974 124.034 75.0581 127.533 69.6023 130.013C64.1466 132.548 57.8917 133.842 50.8378 133.898C40.4774 133.842 31.4947 131.198 23.8897 125.963C16.3398 120.783 10.4707 113.289 6.28242 103.481C2.14927 93.7283 0.082691 81.964 0.0826916 68.1886C0.0826922 54.5233 2.17682 42.6213 6.36509 32.4825C10.5533 22.3989 16.7531 14.5193 24.9643 8.84385C33.2306 3.22346 43.4533 0.275509 55.6323 0V34.6315C49.9561 35.0172 45.2167 36.6427 41.4142 39.508C37.6668 42.4284 34.8287 46.3131 32.8999 51.1621C31.0262 56.0661 30.0894 61.6039 30.0894 67.7753C30.0894 73.8365 30.9711 79.0987 32.7346 83.562C34.4981 88.0803 36.9504 91.5793 40.0916 94.0589C43.2328 96.5385 46.8424 97.7783 50.9205 97.7783C54.723 97.7783 57.9193 96.6487 60.5094 94.3895C63.0995 92.1854 65.3038 88.9344 67.1224 84.6365C68.941 80.3936 70.5943 75.1865 72.0822 69.0151L76.7114 50.5835C80.1832 36.3121 85.6114 25.0438 92.996 16.7785C100.381 8.51324 110.328 4.40815 122.837 4.46325C133.088 4.40815 142.043 7.13569 149.703 12.6459C157.363 18.2112 163.342 25.8428 167.641 35.5407C171.939 45.2386 174.088 56.259 174.088 68.6018C174.088 81.165 171.939 92.1303 167.641 101.498C163.342 110.92 157.363 118.249 149.703 123.483C142.043 128.718 133.17 131.418 123.085 131.583V97.2823Z"
              fill="#0D0D0D"
            />
            <path
              d="M2.28143e-05 201.201C2.33852e-05 188.142 2.64524 176.901 7.93568 167.479C13.2812 158.111 20.8311 150.893 30.5854 145.823C40.3947 140.754 51.9951 138.219 65.3865 138.219C78.4473 138.219 89.9099 140.754 99.7744 145.823C109.639 150.893 117.326 158.029 122.837 167.231C128.348 176.488 131.104 187.343 131.104 199.796C131.104 208.171 129.753 215.968 127.053 223.186C124.408 230.46 120.413 236.797 115.067 242.197C109.721 247.652 102.998 251.895 94.8972 254.925C86.8514 257.956 77.4278 259.471 66.6264 259.471H56.9549L56.9549 152.27H78.7779L78.7779 226.327C83.8479 226.327 88.3393 225.225 92.252 223.021C96.1647 220.817 99.2233 217.759 101.428 213.847C103.687 209.99 104.817 205.499 104.817 200.374C104.817 195.029 103.577 190.291 101.097 186.158C98.6722 182.081 95.3932 178.885 91.26 176.57C87.182 174.256 82.6355 173.071 77.6206 173.016L56.8722 173.016C50.5898 173.016 45.1616 174.173 40.5876 176.488C36.0136 178.857 32.4866 182.191 30.0067 186.489C27.5268 190.787 26.2869 195.884 26.2869 201.779C26.2869 205.692 26.838 209.273 27.9401 212.524C29.0423 215.775 30.6956 218.558 32.8999 220.872C35.1043 223.186 37.8046 224.95 41.0009 226.162L38.8517 258.727C31.0262 257.074 24.1927 253.685 18.3512 248.561C12.5648 243.492 8.04589 236.934 4.79448 228.89C1.59817 220.9 2.23566e-05 211.67 2.28143e-05 201.201Z"
              fill="#0D0D0D"
            />
            <path
              d="M0.0826813 304.685C0.0826816 296.585 1.48795 289.367 4.2985 283.03C7.16415 276.694 11.38 271.679 16.9459 267.988C22.567 264.351 29.5658 262.533 37.9424 262.533C44.9963 262.533 50.9205 263.827 55.7149 266.417C60.5094 269.007 64.367 272.534 67.2878 276.997C70.2085 281.46 72.4129 286.529 73.9008 292.205C75.3887 297.935 76.4358 303.942 77.042 310.223C77.8135 317.607 78.5299 323.558 79.1912 328.076C79.9076 332.595 80.9547 335.873 82.3324 337.912C83.7102 339.951 85.7492 340.97 88.4495 340.97H88.9455C94.1808 340.97 98.2313 339.317 101.097 336.011C103.963 332.76 105.395 328.131 105.395 322.125C105.395 315.788 103.99 310.747 101.18 307C98.4242 303.253 94.9523 300.773 90.7641 299.561L93.4093 266.996C101.125 268.649 107.793 271.9 113.414 276.749C119.09 281.598 123.444 287.852 126.475 295.511C129.561 303.225 131.104 312.152 131.104 322.29C131.104 329.344 130.277 336.094 128.624 342.54C126.97 349.042 124.408 354.801 120.936 359.815C117.464 364.884 113 368.879 107.545 371.799C102.144 374.72 95.6687 376.18 88.1189 376.18H2.47991L2.47991 342.788H20.0871V341.797C16.1193 339.758 12.6199 337.03 9.58893 333.614C6.61306 330.198 4.27094 326.093 2.56257 321.299C0.909311 316.505 0.082681 310.967 0.0826813 304.685ZM24.3856 314.769C24.3856 319.949 25.4051 324.522 27.4442 328.489C29.5383 332.457 32.3488 335.57 35.8758 337.829C39.4027 340.088 43.3981 341.218 47.8619 341.218H61.336C60.6196 340.116 59.9583 338.601 59.3521 336.672C58.801 334.799 58.2775 332.677 57.7815 330.308C57.3406 327.938 56.9273 325.569 56.5416 323.2C56.2109 320.83 55.9078 318.681 55.6323 316.753C55.0261 312.62 54.0617 309.011 52.7391 305.925C51.4164 302.84 49.6254 300.443 47.366 298.734C45.1616 297.026 42.4062 296.172 39.0997 296.172C34.3052 296.172 30.6405 297.908 28.1055 301.379C25.6256 304.906 24.3856 309.369 24.3856 314.769Z"
              fill="#0D0D0D"
            />
            <path
              d="M129.45 457.059H102.998V380.605H129.45V457.059ZM159.87 397.962V433.173H41.4969C38.2455 433.173 35.7105 433.668 33.8919 434.66C32.1284 435.652 30.8884 437.03 30.172 438.793C29.4556 440.611 29.0974 442.705 29.0974 445.074C29.0974 446.728 29.2352 448.381 29.5107 450.034C29.8414 451.687 30.0894 452.954 30.2547 453.836L4.0505 459.373C3.49941 457.61 2.86566 455.131 2.14925 451.935C1.37773 448.739 0.909306 444.854 0.74398 440.281C0.413328 431.795 1.54306 424.356 4.13317 417.964C6.72328 411.628 10.7462 406.696 16.202 403.17C21.6577 399.643 28.5463 397.907 36.8677 397.962H159.87Z"
              fill="#0D0D0D"
            />
            <path
              d="M8.7671e-06 522.523C9.338e-06 509.464 2.64523 498.224 7.93567 488.801C13.2812 479.434 20.8311 472.215 30.5853 467.146C40.3947 462.077 51.9951 459.542 65.3865 459.542C78.4473 459.542 89.9099 462.077 99.7743 467.146C109.639 472.215 117.326 479.351 122.837 488.553C128.348 497.81 131.104 508.665 131.104 521.118C131.104 529.494 129.753 537.291 127.053 544.509C124.408 551.783 120.413 558.119 115.067 563.519C109.721 568.974 102.998 573.217 94.8972 576.248C86.8513 579.278 77.4277 580.794 66.6264 580.794H56.9549L56.9549 473.593H78.7779L78.7779 547.65C83.8479 547.65 88.3393 546.548 92.252 544.344C96.1647 542.14 99.2232 539.082 101.428 535.169C103.687 531.312 104.817 526.821 104.817 521.697C104.817 516.352 103.577 511.613 101.097 507.481C98.6722 503.403 95.3932 500.207 91.26 497.893C87.182 495.579 82.6355 494.394 77.6206 494.339H56.8722C50.5898 494.339 45.1616 495.496 40.5876 497.81C36.0135 500.18 32.4866 503.513 30.0067 507.811C27.5268 512.109 26.2869 517.206 26.2869 523.102C26.2869 527.014 26.838 530.596 27.9401 533.847C29.0423 537.098 30.6956 539.881 32.8999 542.195C35.1043 544.509 37.8046 546.272 41.0009 547.485L38.8516 580.05C31.0262 578.397 24.1927 575.008 18.3512 569.883C12.5648 564.814 8.04588 558.257 4.79447 550.212C1.59816 542.222 8.30941e-06 532.993 8.7671e-06 522.523Z"
              fill="#0D0D0D"
            />
            <path
              d="M2.4799 589.806H129.45V623.942H107.297V625.264C115.177 627.578 121.129 631.463 125.152 636.918C129.23 642.373 131.269 648.655 131.269 655.763C131.269 657.526 131.159 659.427 130.938 661.466C130.718 663.505 130.415 665.296 130.029 666.839H98.7824C99.2784 665.186 99.7192 662.899 100.105 659.978C100.491 657.058 100.684 654.385 100.684 651.961C100.684 646.781 99.5539 642.153 97.2944 638.075C95.0901 634.053 92.004 630.857 88.0362 628.488C84.0683 626.173 79.4943 625.016 74.3141 625.016H2.4799L2.4799 589.806Z"
              fill="#0D0D0D"
            />
            <path
              d="M93.2439 776.708L91.26 744.473C94.0155 743.922 96.4954 742.738 98.6997 740.919C100.959 739.101 102.75 736.704 104.073 733.729C105.451 730.808 106.139 727.309 106.139 723.232C106.139 717.777 104.982 713.176 102.668 709.429C100.408 705.682 97.3771 703.808 93.5746 703.808C90.5436 703.808 87.9811 705.021 85.8869 707.445C83.7928 709.869 82.112 714.03 80.8445 719.926L76.2153 742.903C73.6804 755.246 69.6023 764.448 63.9812 770.509C58.3601 776.57 50.9756 779.601 41.8275 779.601C33.5061 779.601 26.2042 777.149 19.9218 772.245C13.6394 767.396 8.73473 760.729 5.20777 752.243C1.73592 743.812 -4.81776e-07 734.087 0 723.066C7.34708e-07 706.26 3.4994 692.871 10.4982 682.897C17.5521 672.979 27.141 667.166 39.265 665.457L41.0835 700.089C35.9584 701.136 32.0457 703.671 29.3454 707.693C26.7002 711.715 25.3776 716.867 25.3776 723.149C25.3776 729.32 26.5624 734.28 28.9321 738.027C31.3569 741.829 34.4705 743.757 38.273 743.812C41.4693 743.757 44.087 742.407 46.126 739.762C48.2201 737.117 49.8183 733.04 50.9204 727.53L55.3016 705.544C57.7815 693.146 62.08 683.917 68.197 677.855C74.3141 671.849 82.112 668.846 91.5907 668.846C99.7468 668.846 106.773 671.05 112.67 675.458C118.566 679.922 123.113 686.176 126.309 694.221C129.505 702.321 131.104 711.798 131.104 722.653C131.104 738.688 127.714 751.306 120.936 760.508C114.158 769.765 104.927 775.165 93.2439 776.708Z"
              fill="#0D0D0D"
            />
            <path
              d="M130.625 810.504C135.684 810.504 140.28 811.727 144.413 814.174C148.579 816.653 151.902 819.976 154.382 824.142C156.862 828.307 158.102 832.919 158.102 837.978C158.102 842.408 157.11 846.507 155.126 850.276C153.175 854.078 150.513 857.186 147.141 859.6C143.768 862.046 139.949 863.517 135.684 864.013V848.342C137.899 847.88 139.685 846.673 141.04 844.722C142.429 842.772 143.123 840.523 143.123 837.978C143.123 835.696 142.561 833.614 141.437 831.729C140.346 829.845 138.858 828.324 136.973 827.167C135.088 826.043 132.989 825.481 130.674 825.481C128.393 825.481 126.293 826.043 124.375 827.167C122.491 828.324 120.97 829.845 119.812 831.729C118.688 833.614 118.126 835.696 118.126 837.978C118.126 840.523 118.804 842.738 120.16 844.623C121.548 846.507 123.35 847.681 125.566 848.144V863.815C121.3 863.319 117.481 861.864 114.109 859.451C110.736 857.07 108.058 854.012 106.074 850.276C104.123 846.541 103.147 842.441 103.147 837.978C103.147 832.919 104.387 828.307 106.867 824.142C109.347 819.976 112.654 816.653 116.787 814.174C120.953 811.727 125.566 810.504 130.625 810.504ZM78.2493 837.631C78.2493 830.423 79.605 823.646 82.3164 817.298C85.0277 810.983 88.7806 805.413 93.5751 800.586C98.4026 795.792 103.974 792.023 110.29 789.279C116.605 786.568 123.383 785.229 130.625 785.262C137.866 785.295 144.644 786.667 150.96 789.378C157.275 792.122 162.83 795.891 167.625 800.685C172.452 805.479 176.222 811.033 178.933 817.348C181.644 823.662 183 830.423 183 837.631C183 844.871 181.644 851.648 178.933 857.963C176.222 864.311 172.452 869.865 167.625 874.626C162.83 879.42 157.275 883.172 150.96 885.883C144.644 888.594 137.866 889.966 130.625 889.999C123.383 890.032 116.605 888.693 110.29 885.982C103.974 883.271 98.4026 879.519 93.5751 874.725C88.7806 869.931 85.0277 864.361 82.3164 858.013C79.605 851.665 78.2493 844.871 78.2493 837.631ZM96.4022 837.631C96.4022 842.391 97.2949 846.838 99.0804 850.971C100.866 855.136 103.313 858.773 106.421 861.881C109.562 864.989 113.183 867.419 117.283 869.171C121.416 870.956 125.847 871.849 130.575 871.849C135.336 871.816 139.784 870.907 143.917 869.121C148.083 867.369 151.72 864.922 154.828 861.782C157.937 858.674 160.383 855.054 162.169 850.921C163.954 846.789 164.847 842.358 164.847 837.631C164.847 832.936 163.954 828.522 162.169 824.39C160.383 820.29 157.92 816.67 154.779 813.529C151.638 810.388 148 807.925 143.867 806.14C139.734 804.355 135.303 803.445 130.575 803.412C125.88 803.412 121.466 804.288 117.332 806.041C113.232 807.826 109.612 810.289 106.471 813.43C103.329 816.571 100.866 820.207 99.0804 824.34C97.2949 828.473 96.4022 832.903 96.4022 837.631Z"
              fill="#0D0D0D"
            />
          </svg>
        </div>
        <motion.div
          ref={ref}
          className={styles.badge}
          initial={{ opacity: 0, scale: 0.5, rotate: 90, x: '-50%' }}
          animate={isInView ? { opacity: 1, scale: 1, rotate: 0, x: '-50%' } : {}}
          transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
        >
          <img
            className={styles.logoBadge}
            src="/images/logoBadge.svg"
            alt=""
            width={60}
            height={47}
            loading="lazy"
          />
          <img
            className={styles.circleTextBadge}
            src="/images/circleTextBadge.svg"
            alt=""
            width={165}
            height={165}
            loading="lazy"
          />
        </motion.div>
      </div>
    </section>
  )
}

export default HomeOffer
